import * as React from "react";
import { useEffect } from "react";
import { CssBaseline } from "@mui/material";
import HeaderSection          from "../components/common/header/Header";
import LandingHeroSection     from "../components/landing/hero/Hero";
import LandingWhyusSection    from "../components/landing/whyus/Whyus";
import LandingPricingSection  from "../components/landing/pricing/Pricing";
import LandingWorksSection    from "../components/landing/workssection/WorksSection";
import LandingTestimonials    from "../components/landing/testimonials/TestimonialsSection";
import SubscribeThroughEmail  from "../components/common/subscribe/SubscribeEmail";
import StatsBar               from "../components/landing/stats/StatsBar";
function LandingPage() {
  const [showContactForm, setShowContactForm] = React.useState(false);

  React.useEffect(() => {
    document.title = "Meesha – India's #1 Creator Intelligence Platform";
  }, []);

  /* Global scroll-reveal observer */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -32px 0px" }
    );

    const timer = setTimeout(() => {
      document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    }, 0);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  const handleShowContactForm  = () => setShowContactForm(true);
  const handleCloseContactForm = () => setShowContactForm(false);

  return (
    <>
      <CssBaseline />
      <HeaderSection
        showNav={true}
        handleShowContactForm={handleShowContactForm}
        handleCloseContactForm={handleCloseContactForm}
        showContactForm={showContactForm}
      />
      <LandingHeroSection handleShowContactForm={handleShowContactForm} />
      <StatsBar />
      <LandingWhyusSection />
      <LandingWorksSection />
      {/* <LandingPricingSection /> */}
      <LandingTestimonials />
      <SubscribeThroughEmail />
    </>
  );
}

export default LandingPage;
